import { render, staticRenderFns } from "./BountyPayoutGradientIcon.vue?vue&type=template&id=9bb6abda&scoped=true"
import script from "./BountyPayoutGradientIcon.vue?vue&type=script&lang=js"
export * from "./BountyPayoutGradientIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb6abda",
  null
  
)

export default component.exports